module.exports = __webpack_public_path__ + "static/Connected-Fleet-29e06cad6ea8500ec329d1fe9ddf7410.jpg";